module.exports = __webpack_public_path__ + "img/re1.e3de689c.jpg";